import type { SVGProps } from "react";
import { memo } from "react";
const Private5G = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#4D27A8" />
        <stop offset="100%" stopColor="#A166FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m31.221 20.755-8.997-6.837 1.211-1.593 8.997 6.837zm16.958-.025-1.211-1.593 8.996-6.837 1.211 1.593zM42 61.01h3v-3h-3zm-7 0h3v-3h-3zm7-7h3v-3h-3zm-7 0h3v-3h-3zm20.964-17.865-8.996-6.837 1.211-1.593 8.996 6.837zM50 26.01h14v-2H50zm-18.779 1.73 1.211 1.593-8.997 6.837-1.211-1.593zM17 26.01h14v-2H17zm33 39.666V58.56c11.558 1.014 15.757 2.931 15.99 3.751-.464 1.033-6.012 2.669-15.99 3.365m-2 .126c-2.438.13-5.099.208-8 .208s-5.561-.078-8-.208V47.01h16zm-18-9.216c-5.974.504-12.515 1.439-15.823 3.173C15.659 47.865 26.065 38.775 39 38.323v6.687h-9zm0 9.091c-10.036-.699-15.594-2.343-15.997-3.342.204-.811 4.403-2.737 15.997-3.737zm6-41.667c0-2.205 1.794-4 4-4s4 1.795 4 4-1.794 4-4 4-4-1.794-4-4m29.706 35.678c-3.333-1.7-9.766-2.631-15.706-3.14V45.01h-9v-6.686c12.298.471 22.767 9.662 24.706 21.364m2.29 2.594.003-.001C67.29 48.278 55.276 36.833 41 36.324V29.92c2.833-.478 5-2.942 5-5.91 0-3.308-2.691-6-6-6-3.308 0-6 2.692-6 6 0 2.968 2.167 5.432 5 5.91v6.403c-14.841.484-26.616 11.577-27 25.66l.035.001q-.034.171-.035.348c0 5.614 26.857 5.678 28 5.678s28-.064 28-5.678q-.002-.025-.004-.05"
      />
    </g>
  </svg>
);
const Memo = memo(Private5G);
export default Memo;
